import { createFileRoute, notFound } from '@tanstack/react-router';
import { ensurePublishedPrices } from '../../../features/catalog/queries';
import { EditorialPostPage } from '../../../features/editorial/EditorialPostPage';
import { articleHead } from '../../../features/editorial/articleHead';
import { NotFoundPage } from '../../../pages/NotFoundPage';
import { getPostMeta, postUrl } from '../../../lib/blog/meta';
import { getPost } from '../../../lib/blog/posts';

export const Route = createFileRoute('/_site/blog/$slug')({
  staticData: { footer: 'slim' },
  // The published prices, so an article's `<Price>` tags render into the
  // prerendered HTML rather than after a browser fetch.
  loader: async ({ context, params }) => {
    const post = getPostMeta(params.slug);
    if (!post) throw notFound();
    await ensurePublishedPrices(context.queryClient);
    return { fm: post.frontmatter, slug: post.slug };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { fm, slug } = loaderData;
    return articleHead(fm, postUrl(slug));
  },
  component: BlogPostRoute,
});

function BlogPostRoute() {
  const { slug } = Route.useParams();
  const post = getPost(slug);
  if (!post) return <NotFoundPage />;
  return (
    <EditorialPostPage
      post={post}
      canonicalUrl={postUrl(slug)}
      section={{ name: 'Blog', href: '/blog', url: 'https://getanyapi.com/blog' }}
    />
  );
}
